<template>
  <div>
    <!-- <p>{{ GetBranches }}</p> -->
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
        v-for="(branch, index) in GetBranches"
        :key="index"
      >
        <branch :branch="branch"></branch>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import branch from "./branchView";
export default {
  name: "HQ_Home",
  components: {
    branch,
  },
  data() {
    return {
      // Branches: []
    };
  },
  computed: {
    ...mapGetters(["GetBranches"]),
  },
  methods: {
    // loadBaraches() {
    //   this.$store
    //     .dispatch("GET_ONLY", "/branches")
    //     .then(branches => {
    //       // this.Branches = branches.data;
    //       // console.log("called");
    //       this.$store.commit("SAVE_BRANCHES", branches.data);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // }
  },
  mounted() {
    // /* if (!this.GetBranches.length)  */ this.$store.dispatch("loadBaraches");
  },
};
</script>
